import { ArcGauge } from '@nwwp/ui-shadcn'
import type { CalculatorResults } from '../types'

const COLORS = {
  green: 'var(--color-green)',
  red: 'var(--color-red)',
  gold: 'var(--color-gold)',
}

export function GaugeSVG({ results }: { results: CalculatorResults }) {
  const color = results.winner === 'buy' ? COLORS.green : results.winner === 'rent' ? COLORS.red : COLORS.gold
  const label = results.winner === 'buy' ? 'Buying Wins' : results.winner === 'rent' ? 'Renting Wins' : 'Even'
  const display = `${results.savingsPct}% less`

  return <ArcGauge fill={Math.min(results.savingsPct / 30, 1)} color={color} label={label} display={display} />
}
